import React, { useContext, useEffect, useState } from 'react';
import styles from './SearchBarDistanceSelect.module.scss';
import { checkValidZip, distanceOptions, evaluateIsDisabled } from '../../../lib/util';
import { AppContext } from '../../../context/AppContext';
import * as _ from 'lodash';
import { defaultAppState } from '../../../context/DefaultAppState';

const SeachBarDistanceSelect = () => {
  const { search, location, distance, updateDistance, updateSearch, updateIsDisabled } = useContext(AppContext);

  /* useEffect(() => {
    console.log('location: ',location)
    let newSearch = search;
    if (distance.distance !== defaultAppState.distance.distance) {
      newSearch = { ...newSearch, required: true }
    }
    console.log(newSearch);
    
    updateSearch( newSearch );
    updateIsDisabled(evaluateIsDisabled(newSearch, location));

  }, [distance]); */

  const distances = distanceOptions();

  return (
    <div className={styles.distanceSelectContainer}>
      <select
        className={styles.distanceSelect}
        value={distance.name}
        onChange={(e) => {
          let newDistance = distances[0];
          const foundDistance = distances.find( (distanceObj) => distanceObj.name === e.target.value);
          newDistance = foundDistance ? foundDistance : newDistance;
          updateDistance(newDistance);

          let newSearch = search;
          if (newDistance.distance !== defaultAppState.distance.distance) {
            //console.log(newDistance.distance, defaultAppState.distance.distance )
            newSearch = { ...newSearch, required: true }
          } else {
            newSearch = { ...newSearch, required: false }
          }
          const result = checkValidZip(location)
          newSearch.isValidZIP = result
          //console.log(newSearch);
          
          updateSearch( newSearch );
          let currentLocation = location ? location : null;
          const evaldis = evaluateIsDisabled(newSearch, currentLocation, distance.distance);
          //console.log(evaldis);
          updateIsDisabled(evaldis);  
        }}
      >
        {distances.map((distance) => {
          return (
            <option key={`sbds-${distance.name}`} value={distance.name}>
              {distance.name}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SeachBarDistanceSelect;
